import {
    initTexts,
    getServerTexts as getTexts,
    texts as localization
} from '../../Localization/texts';

export const entity = 'UI_ADP';

export const en = {
    settings_planned:
        'Here you can choose to group the planned items, and select the fields you want to show in the list.',
    show_planned_locations: 'Show locations on map',
    only_planned: 'Only Planned',
    only_routes: 'Only Routes',
    planned_map: 'Planned & map',
    routes_map: 'Routes & map',
    enlarged_map: 'Enlarged map',
    optimization_cancel_title: 'Optimization in progress',
    optimization_cancel_explanation:
        'The optimization process is still running and will stop if you close.',
    optimization_cancel_close_button: 'Close anyway',
    planned_routes_map: 'Planned, routes, & map',
    only_map: 'Only map',
    choose_view: 'Choose view',
    documents: 'Documents',
    orders: 'Orders',
    ADP_title: 'Advanced Delivery Planning',
    add_to_favorites: 'Add to Favorites',
    reload_form: 'Reload this form',
    search_route: 'Search routes...',
    help_icon: 'Priority Helpbook - Form help and relevant videos, SOPs and FAQs',
    exit_form: 'Exit form (Esc)',
    no_options_text: 'We did not find results for your search.',
    not_found_planned:
        'We did not find results that match your search. Widen your search to find more results.',
    auto_planning: 'Automatic Planning',
    help_tooltip: 'Help',
    close_tooltip: 'Close',
    delivery_date: 'Delivery date',
    add_to_route_btn: 'Add to route',
    cancel_btn: 'Cancel',
    empty_state_planned: 'Your planned documents, sales orders, and tasks will appear here.',
    empty_state_routes:
        'Your routes will appear here.\nFind your routes by using the filter.\nAdd new routes by clicking the New button, or use the Assign with aiERP button.',
    not_found_routes:
        'We did not find results that match your search. Widen your search to find more results.',
    planned: 'Planned',
    saved_searches: 'Saved Searches',
    show_items: 'Show items',
    routes: 'Routes',
    group_by: 'Group by',
    choose_fields_to_view: 'Choose fields to view',
    assign_to_route: 'Assign to route',
    assign_to_tooltip: 'Assign your plan items to defined routes.',
    show_route_lines: 'Show route lines',
    show_addresses: 'Show addresses',
    show_start_end: 'Show start & end',
    change_status: 'Change status',
    new: 'New',
    //without microcopy
    selectRoute: 'Select route',
    selectAll: 'Select all',
    deselect: 'Deselect',
    schedule: 'Automatic Planning',
    //=================
    clear_all: 'Clear all',
    nothing_selected: '0 selected',
    selected_docs: 'Selected',
    X_routes_selected: 'X routes selected',
    X_documents_selected: 'X documents selected',
    change_status_to: 'Change status to',
    select_route_color: 'Select route color',
    exceed_msg_title: 'The number of results exceeds the maximum',
    exceed_msg_text:
        'Click the button again to adjust the parameters and reduce the number of results.',
    load_data: 'Upload data',
    clear_all_selected: 'Clear all',
    select_fields_totals: 'Select fields for totals',
    select_fields_title: 'Select fields for titles',
    select_fields_list: 'Select fields for list',
    drag_x_items: 'Move X items',
    select_fields: 'Choose Fields for',
    planned_title: 'Planned',
    planned_help_text:
        'Here you can choose which fields will appear in the Planned section.\nOn the left are the available fields to choose from.\nTo add fields, mark the checkbox, and they will move to the right.\nTo clear fields from the panel, click on the X.',
    route_title_title: 'Title',
    route_title_help_text:
        'Here you can choose which fields will appear in the Titles section.\nOn the left are the available fields to choose from.\nTo add fields, mark the checkbox, and they will move to the right.\nTo clear fields from the panel, click on the X.',
    route_totals_title: 'Totals',
    route_totals_help_text:
        'Here you can choose which fields will appear in the Totals section.\nOn the left are the available fields to choose from.\nTo add fields, mark the checkbox, and they will move to the right.\nTo clear fields from the panel, click on the X.',
    select_fields_for: 'Choose Fields for',
    route_details_title: 'Routes',
    route_details_help_text:
        'Here you can choose which fields will appear in the Routes section.\nOn the left are the available fields to choose from.\nTo add fields, mark the checkbox, and they will move to the right.\nTo clear fields from the panel, click on the X.',
    collapsed_and_totals: 'Collapsed view + totals',
    collapsed: 'Collapsed view',
    show_selected_routes: 'Show selected routes',
    show_all_routes: 'Show all routes',
    settings_show_totals: 'Show totals',
    routes_settings_tooltip: 'Here you can select the fields you want to show in the list.',
    routes_exceed_msg_title: 'The number of routes exceeds the maximum',
    routes_exceed_msg_text: 'Use the filter to reduce the number of results.',
    cust_initials_tooltip: 'The customer’s initials',
    expand_tooltip: 'Expand / Collapse',
    auto_planning_tooltip: 'Automatically assign items to routes.',
    helpbok_title: 'Advanced Delivery Planning (ADP)',
    helpbok_text:
        'Use the @Advanced Delivery Planning interface (ADP)@ to create and manage delivery routes according to your business needs. \n\nThe ADP is split into the following three sections: \n# @Unassigned@ - Use this section to load shipping documents and orders to the interface and assign them to delivery routes. You can automatically assign shipping documents, or drag and drop them into a specific route. Unassigned delivery documents and orders are retained in the system and displayed the next time the ADP is used. \n@Routes@ - Use this section to optimize delivery routes that are defined in the "Delivery Tracking Documents" form. You can reassign a delivery or order by dragging the record from one route and dropping it into another.\n@Map@ - Routes appear in this section in a distinct color, ensuring clear route visualization and easy differentiation.#',
    auto_planning_instruction_text:
        'Use this program to automatically assign records to delivery routes. When necessary, running this program also creates new Delivery Tracking Documents for the records.',
    display_all: 'all',
    assign_automatically: 'Assign automatically',
    clear_search: 'Clear search',
    saved_searches_tooltip: 'See your saved searches, or create new ones with Advanced Search.',
    search_placeholder: 'Search...',
    selected_dest: 'selected',
    unassigned_automatically_explanation:
        'Enter your preferred delivery date for the documents, or leave blank if you want the system to assign the date based on the defined date in each document.',
    optimization_transactions_warning:
        'You have #% of your monthly transaction limit remaining.\n' +
        'Consult with your Priority contact to purchase more transactions and continue using AI optimization.'
};

export const he = {
    settings_planned: 'כאן אפשר לקבץ שורות ברשימה ולבחור את הנתונים להצגה.',
    show_planned_locations: 'הציגו מיקומים על המפה',
    only_planned: 'רק לתכנון',
    only_routes: 'רק מסלולים',
    planned_map: 'לתכנון ומפה',
    routes_map: 'מסלולים ומפה',
    enlarged_map: 'מפה גדולה',
    only_map: 'רק מפה',
    planned_routes_map: 'לתכנון, מסלולים ומפה',
    choose_view: 'תצוגה',
    documents: 'תעודות',
    orders: 'הזמנות לקוח',
    ADP_title: 'מעקב אספקות מתקדם',
    add_to_favorites: 'הוספה לתפריט אישי',
    reload_form: 'רענון נתונים ',
    search_route: 'בחרו מסלול',
    exit_form: 'סגירת מסך (Esc)',
    help_icon: 'Priority Helpbook - עזרה למסך, הוראות הפעלה ו- FAQs רלוונטיים',
    no_options_text: 'אין תוצאות',
    not_found_planned: 'לא מצאנו נתונים מתאימים לחיפוש. הרחיבו את טווח החיפוש.',
    auto_planning: 'תכנון אוטומטי',
    help_tooltip: 'עזרה',
    close_tooltip: 'סגירה',
    delivery_date: 'תאריך הפצה',
    add_to_route_btn: 'להעביר למסלול',
    cancel_btn: 'ביטול',
    empty_state_planned: 'תעודות, הזמנות לקוח ומשימות לתכנון יופיעו כאן.',
    empty_state_routes: `המסלולים שלך יופיעו כאן.
השתמשו בחיפושים שמורים כדי להציג מסלולים.
הוסיפו מסלולים חדשים בלחיצה על כפתור חדש או ע"י שיבוץ עם aiERP.`,
    not_found_routes: 'לא מצאנו נתונים מתאימים לחיפוש. הרחיבו את טווח החיפוש.',
    planned: 'לתכנון',
    saved_searches: 'חיפושים שמורים',
    show_items: 'להציג',
    routes: 'מסלולים',
    group_by: 'קיבוץ לפי',
    choose_fields_to_view: 'בחירת שדות לעמודות',
    assign_to_route: 'שיבוץ במסלול',
    assign_to_tooltip: 'בחרו מסלול לשיבוץ המשלוח.',
    show_route_lines: 'הצגת קווי מסלול',
    show_addresses: 'הצגת כתובות',
    show_start_end: 'הצגת התחלה וסיום',
    change_status: 'שינוי סטטוס',
    new: 'חדש',
    //without microcopy
    selectRoute: 'בחר מסלול',
    selectAll: 'בחר הכל',
    deselect: 'בטל את הבחירה',
    //=================
    schedule: 'תכנון אוטומטי',
    clear_all: 'ניקוי בחירה',
    nothing_selected: '0 נבחרו',
    selected_docs: 'תעודות נבחרו',
    X_routes_selected: 'X מסלולים נבחרו',
    change_status_to: 'שינוי סטטוס',
    select_route_color: 'בחירת צבע המסלול',
    X_documents_selected: 'X תעודות נבחרו',
    exceed_msg_title: 'מספר התוצאות עבר את המקסימום',
    exceed_msg_text: 'לחצו שוב על הכפתור כדי לעדכן את הפרמטרים ולצמצם את מספר',
    load_data: 'טעינת נתונים',
    clear_all_selected: 'ניקוי בחירה',
    select_fields_totals: 'בחירת שדות מסוכמים בכותרת',
    select_fields_title: 'בחירת שדות כותרת',
    select_fields_list: 'בחירת שדות לעמודות',
    drag_x_items: 'מעבירים X פריטים',
    select_fields: 'בחירת שדות',
    planned_title: 'לתכנון',
    planned_help_text:
        'כאן בוחרים אילו פרטים יופיעו באיזור "לתכנון".\nבצד ימין מופיעים השדות שאפשר להציג.\nסמנו את השדות הרלוונטיים לכם והם יופיעו ב"שדות להצגה"\nבצד שמאל. כדי להסיר שדה, לחצו על ה- X בשדה הרלוונטי.',
    route_title_title: 'לכותרת',
    route_title_help_text:
        'כאן בוחרים אילו פרטים יופיעו בשורת הכותרת.\nבצד ימין מופיעים השדות שאפשר להציג.\nסמנו את השדות הרלוונטיים לכם והם יופיעו ב"שדות להצגה"\nבצד שמאל. כדי להסיר שדה, לחצו על ה- X בשדה הרלוונטי.',
    route_totals_title: 'מסוכמים בכותרת',
    route_totals_help_text:
        'כאן בוחרים אילו פרטים יופיעו שורת "הסיכום בכותרת".\nבצד ימין מופיעים השדות שאפשר להציג.\nסמנו את השדות הרלוונטיים לכם והם יופיעו ב"שדות להצגה"\nבצד שמאל. כדי להסיר שדה, לחצו על ה- X בשדה הרלוונטי.',
    select_fields_for: 'בחירת שדות ל',
    route_details_title: 'מסלולים',
    route_details_help_text:
        'כאן בוחרים אילו פרטים יופיעו באיזור "מסלולים".\nבצד ימין מופיעים השדות שאפשר להציג.\nסמנו את השדות הרלוונטיים לכם והם יופיעו ב"שדות להצגה"\nבצד שמאל. כדי להסיר שדה, לחצו על ה- X בשדה הרלוונטי.',
    collapsed_and_totals: 'תצוגה מצומצמת + סיכומים',
    collapsed: 'תצוגה מצומצמת',
    show_selected_routes: 'הצגת מסלולים נבחרים',
    show_all_routes: 'הצגת כל המסלולים',
    settings_show_totals: 'הצגת סיכומים',
    routes_settings_tooltip: 'כאן אפשר לבחור את הנתונים להצגה.',
    routes_exceed_msg_title: 'מספר המסלולים עבר את המקסימום',
    routes_exceed_msg_text: 'בחרו באפשרות הסינון כדי לצמצם את מספר התוצאות.',
    cust_initials_tooltip: 'ראשי תיבות של הלקוח',
    expand_tooltip: 'הרחבה / צמצום',
    auto_planning_tooltip: 'שבצו משלוחים מסומנים בצורה אוטומטית',
    helpbok_title: 'תכנון הפצה מתקדם (ADP)',
    helpbok_text:
        'השתמשו בממשק @תכנון הפצה מתקדם (ADP)@ כדי ליצור ולנהל מסלולי הפצה בהתאם לצורכי העסק שלכם.\nממשק ה-ADP מחולק לשלושה חלקים הבאים:\n#@לתכנון@ - השתמשו בחלק זה כדי לטעון תעודות משלוח והזמנות לממשק ולשייך אותם למסלולים. תוכלו לשייך תעודות באופן אוטומטי, או לגרור ולשחרר אותם למסלול ספציפי. תעודות משלוח והזמנות שלא שויכו נשמרים במערכת ומוצגים בפעם הבאה שבה משתמשים ב-ADP.\n@מסלולים@ - השתמשו בחלק זה כדי לייעל מסלולים המוגדרים במסך "מסמכי מעקב אספקות". תוכלו לשייך מחדש משלוח או הזמנה על ידי גרירת הרשומה ממסלול אחד ושחרורה לאחר.\n@מפה@ - המסלולים מופיעים בחלק זה בצבע ייחודי, המבטיח המחשה ברורה של המסלול והבחנה קלה.#',
    auto_planning_instruction_text:
        'השתמשו בתוכנית זו כדי לשייך תעודות למסלולים. במידת הצורך, הפעלת תוכנית זו תיצור גם מסמכי מעקב אספקות חדשים עבור הרשומות.',
    display_all: 'הכל',
    assign_automatically: 'שיבוץ אוטומטי',
    clear_search: 'מחיקת חיפוש',
    saved_searches_tooltip: 'כאן תוכלו לצפות בחיפושים השמורים, או ליצור חיפוש חדש.',
    search_placeholder: 'חיפוש...',
    selected_dest: 'יעדים נבחרו'
};
export const mapping = {
    1: 'ADP_title',
    2: 'add_to_favorites',
    3: 'reload_form',
    4: 'help_icon',
    5: 'exit_form',
    6: 'show_items',
    7: 'documents',
    8: 'orders',
    10: 'choose_view',
    11: 'planned_routes_map',
    12: 'only_map',
    13: 'enlarged_map',
    14: 'routes_map',
    15: 'planned_map',
    16: 'only_routes',
    17: 'only_planned',
    18: 'planned',
    19: 'saved_searches',
    20: 'assign_automatically',
    22: 'assign_to_route',
    23: 'assign_to_tooltip',
    25: 'no_options_text',
    24: 'search_route',
    26: 'empty_state_planned',
    27: 'not_found_planned',
    28: 'auto_planning',
    29: 'help_tooltip',
    30: 'close_tooltip',
    31: 'delivery_date',
    32: 'add_to_route_btn',
    33: 'cancel_btn',
    34: 'routes',
    36: 'change_status',
    39: 'new',
    40: 'empty_state_routes',
    41: 'not_found_routes',
    42: 'settings_planned',
    43: 'group_by',
    44: 'choose_fields_to_view',
    45: 'show_planned_locations',
    49: 'schedule',
    51: 'collapsed_and_totals',
    52: 'collapsed',
    53: 'select_fields_totals',
    54: 'select_fields_title',
    55: 'select_fields_list',
    58: 'nothing_selected',
    59: 'X_documents_selected',
    61: 'X_routes_selected',
    62: 'clear_all',
    64: 'change_status_to',
    65: 'select_route_color',
    77: 'select_fields',
    78: 'planned_title',
    79: 'planned_help_text',
    82: 'selected_docs',
    87: 'select_fields_for',
    88: 'route_details_title',
    89: 'route_details_help_text',
    92: 'selected_dest',
    94: 'cancel',
    97: 'drag_x_items',
    98: 'route_totals_title',
    99: 'route_totals_help_text',
    100: 'route_title_title',
    101: 'route_title_help_text',
    103: 'show_route_lines',
    104: 'show_addresses',
    105: 'show_start_end',
    115: 'clear_search',
    116: 'load_data',
    118: 'clear_all_selected',
    121: 'exceed_msg_title',
    122: 'exceed_msg_text',
    123: 'ok_button',
    124: 'show_selected_routes',
    125: 'show_all_routes',
    126: 'settings_show_totals',
    127: 'routes_settings_tooltip',
    128: 'routes_exceed_msg_title',
    129: 'routes_exceed_msg_text',
    130: 'cust_initials_tooltip',
    131: 'expand_tooltip',
    132: 'auto_planning_tooltip',
    133: 'helpbok_title',
    134: 'helpbok_text',
    135: 'auto_planning_instruction_text',
    136: 'display_all',
    137: 'saved_searches_tooltip',
    139: 'search_placeholder',
    140: 'route_optimization_title',
    141: 'route_optimization_help_text',

    142: 'route_optimization_apply_to',
    143: 'route_optimization_apply_to_selected',
    144: 'route_optimization_apply_to_all',
    145: 'route_optimization_apply_to_tooltip',

    146: 'route_optimization_optimize_by',
    147: 'route_optimization_optimize_by_time',
    148: 'route_optimization_optimize_by_distance',
    149: 'route_optimization_optimize_by_tooltip',
    150: 'route_optimization_time_window_consideration',
    151: 'route_optimization_time_window_consideration_tooltip',
    152: 'route_optimization_start_from',
    153: 'route_optimization_start_from_tooltip',
    154: 'route_optimization_run',
    155: 'unassigned_optimization_title',
    156: 'unassigned_optimization_help_text',
    157: 'unassigned_optimization_ai_title',
    158: 'unassigned_optimization_ai_placeholder',
    159: 'unassigned_consider_route',
    160: 'unassigned_consider_area',
    161: 'unassigned_consider_none',
    162: 'unassigned_consider_tooltip',
    163: 'unassigned_consideration_title',
    164: 'unassigned_consideration_tooltip',
    165: 'unassigned_optimization_run',

    167: 'unassigned_automatically_explanation',
    168: 'optimization_delivery_date',
    169: 'optimization_transactions_warning',
    170: 'optimization_exceed_limit',
    171: 'optimization_grace_period',
    172: 'route_optimized_tooltip',
    173: 'optimization_toast_success',
    174: 'optimization_toast_error',
    175: 'optimization_loader_title',
    176: 'optimization_loader_description',
    177: 'optimization_loader_cancel_tooltip',
    178: 'unassigned_optimization_button_tooltip',
    179: 'route_optimization_button_tooltip',
    180: 'no_optimization_module_tooltip',

    191: 'optimization_cancel_title',
    192: 'optimization_cancel_explanation',
    193: 'optimization_cancel_close_button',
    194: 'unassigned_consider_title',
    195: 'optimization_no_coordinates_warning',
    196: 'optimization_unexpected_issue',
    197: 'optimization_unexpected_issue_consult',
    198: 'optimization_unexpected_issue_narrowing',
    199: 'optimization_unexpected_issue_check',
    200: 'optimization_no_trucks_issue',
    201: 'optimization_no_coordinates_issue'
};

const fallbacks = {
    en,
    he
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks according to the user's locale
initTexts(entity, fallbacks);

export const texts = localization[entity];
